import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
const secondHandSuppliesOrdersByPkMutation  = gql`query second_hand_supplies_orders_by_pk($id: uuid!) {
  second_hand_supplies_orders_by_pk(id: $id) {
    id
    created_at
    updated_at
    short_id
    total_amount
    tax_amount
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    dental_practice_id
    dental_practice {
      id
      name
      email
      phone
    }
    dental_professional_id
    dental_professional {
      id
      name
      email
      phone
    }
    dental_supplier_id
    dental_supplier {
      id
      name
      email
      phone
    }
    account_pay_details
    suppliers_id
    sub_total
    order_number
    invoice
    second_hand_supply_id
    second_hand_supply {
      id
      description
      dental_supplier_id
      dental_supplier {
        id
        name
        email
        phone
        business_name
      }
      dental_professional_id
      dental_professional {
        id
        name
        email
        phone
      }
      dental_practice_id
      dental_practice {
        id
        name
        email
        phone
      }
      created_at
      color
      buy_now_price
      bid_starts_at
      bid_ends_at
      image
      is_featured
      more_images
      paused_at
      paused_message
      price_unit
      product_status
      product_type
      rejection_reason
      seo_metadata
      sku
      sold_out_at
      sold_out_message
      specifications
      starting_price
      status
      stop_bid_reason
      supply_brand_id
      supply_category_id
      supply_sub_category_id
      title
      type
      updated_at
      video
    }
    second_hand_supplies_order_notes{
      id
      created_at
      updated_at
      second_hand_supplies_order_id
      status
      message
      extra
    }
  }
}`;
const secondHandSuppliesOrdersByPkSubs  = gql`subscription second_hand_supplies_orders_by_pk($id: uuid!) {
  second_hand_supplies_orders_by_pk(id: $id) {
    id
    created_at
    updated_at
    short_id
    total_amount
    tax_amount
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    dental_practice_id
    dental_practice {
      id
      name
      email
      phone
    }
    dental_professional_id
    dental_professional {
      id
      name
      email
      phone
    }
    dental_supplier_id
    dental_supplier {
      id
      name
      email
      phone
    }
    account_pay_details
    suppliers_id
    sub_total
    order_number
    invoice
    second_hand_supply_id
    second_hand_supply {
      id
      description
      dental_supplier_id
      dental_supplier {
        id
        name
        email
        phone
        business_name
      }
      dental_professional_id
      dental_professional {
        id
        name
        email
        phone
      }
      dental_practice_id
      dental_practice {
        id
        name
        email
        phone
      }
      created_at
      color
      buy_now_price
      bid_starts_at
      bid_ends_at
      image
      is_featured
      more_images
      paused_at
      paused_message
      price_unit
      product_status
      product_type
      rejection_reason
      seo_metadata
      sku
      sold_out_at
      sold_out_message
      specifications
      starting_price
      status
      stop_bid_reason
      supply_brand_id
      supply_category_id
      supply_sub_category_id
      title
      type
      updated_at
      video
    }
    second_hand_supplies_order_notes{
      id
      created_at
      updated_at
      second_hand_supplies_order_id
      status
      message
      extra
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliesOrdersByPkService {

  constructor(private apollo: Apollo) { }

/* --------------------------- suppliesOrdersByPk --------------------------- */
  getSecondHandSuppliesOrdersByPk(id: string): Observable<any>{
    return this.apollo.use('external').query({
      query: secondHandSuppliesOrdersByPkMutation,
      variables: {
        id
      }
    }).pipe(pluck('data', 'second_hand_supplies_orders_by_pk'));
  }

  /* --------------------------- suppliesOrdersByPk --------------------------- */
  getSecondHandSuppliesOrdersByPkSubscription(id: string): Observable<any>{
    return this.apollo.use('external').subscribe({
      query: secondHandSuppliesOrdersByPkSubs,
      variables: {
        id
      }
    }).pipe(pluck('data', 'second_hand_supplies_orders_by_pk'));
  }


}
